// courseListDashboardSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Types
export interface Course {
  course_id: number;
  course_name: string;
}

export interface StudentCourseState {
  isLoading: boolean;
  error: string | null;
  courses: Course[]; // Store courses as an array of Course objects
}

// Initial State
const initialState: StudentCourseState = {
  isLoading: false,
  error: null,
  courses: [],  // Initialize courses as an empty array
};

// Reducer (Slice)
const courseListsStudentDashboardSlice = createSlice({
  name: 'courseListDashboard',
  initialState,
  reducers: {
    setCourseList: (state, action: PayloadAction<Course[]>) => {
      state.courses = action.payload; // Set courses as passed in payload
      state.isLoading = false;
      state.error = null;
    },
    setloading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload; // Set loading state
      // Don't clear error when loading starts, keep error intact
    },
    seterror: (state, action: PayloadAction<string | undefined>) => {
      state.error = action.payload ?? 'Something went wrong'; // Set error message
      state.isLoading = false; // Ensure loading is false when there's an error
    },
    resetCourseListStudent: () => initialState, // Reset to initial state
  },
});

// Export actions and reducer
export const { setCourseList, setloading, seterror, resetCourseListStudent } = courseListsStudentDashboardSlice.actions;
export default courseListsStudentDashboardSlice.reducer;
